module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Files/Group-folders-f2922cd5461a383a53ccd314ec5659c8.svg";